export const FUNDS_TYPE_OPTIONS = [
  {
    text: 'Unknown',
    value: '-',
  },
  {
    text: 'Bank draft',
    value: 'E',
  },
  {
    text: 'Cash',
    value: 'K',
  },
  {
    text: 'Casino chips',
    value: 'D',
  },
  {
    text: 'Cheque',
    value: 'P',
  },
  {
    text: 'Cryptocurrency',
    value: '1',
  },
  {
    text: 'Currency exchange',
    value: 'C',
  },
  {
    text: 'Deposit',
    value: 'A',
  },
  {
    text: 'Dividend warrant',
    value: '2',
  },
  {
    text: 'Electronic funds transfer',
    value: 'B',
  },
  {
    text: 'From account',
    value: 'L',
  },
  {
    text: 'Life insurance policy',
    value: 'H',
  },
  {
    text: 'Money order',
    value: 'F',
  },
  {
    text: 'Other',
    value: 'O',
  },
  {
    text: 'Securities',
    value: 'J',
  },
  {
    text: "Traveller's cheques",
    value: 'G',
  },
  {
    text: 'Withdrawal',
    value: 'W',
  },
] as const;

export type FundsType = (typeof FUNDS_TYPE_OPTIONS)[number]['value'] | '';
